import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { ModuleErrorBannerComponent } from './module-error-banner/module-error-banner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { AlertComponent } from './ui/alert';
import { LoaderComponent } from './ui/loader/loader.component';
import { DocumentViewerComponent } from './ui/document-viewer/document-viewer.component';
import { FiltroResumenGuiasComponent } from './ui/filtro-resumen-guias/filtro-resumen-guias.component';
import { ModalConfirmarDatosComponent } from './ui/modal-confirmar-datos/modal-confirmar-datos.component';
import { ModalExportarComponent } from './ui/modal-exportar/modal-exportar.component';
import { SuccessDialogComponent } from './ui/success-dialog/success-dialog.component';
import { PdfCanvasViewerComponent } from './pdf-canvas-viewer/pdf-canvas-viewer.component';
import { UiTableComponent } from './ui/table/ui-table.component';
import { UiFiltersComponent } from './ui/filters/ui-filters.component';
import { UiBottomSheetComponent } from './ui/bottom-sheet/ui-bottom-sheet.component';
import { UiBottomSheetFooterDirective } from './ui/bottom-sheet/ui-bottom-sheet-footer.directive';

@NgModule({
  declarations: [
    SignaturePadComponent,
    ModuleErrorBannerComponent,
    AlertComponent,
    LoaderComponent,
    DocumentViewerComponent,
    FiltroResumenGuiasComponent,
    ModalConfirmarDatosComponent,
    ModalExportarComponent,
    SuccessDialogComponent,
    PdfCanvasViewerComponent,
    UiTableComponent,
    UiFiltersComponent,
    UiBottomSheetComponent,
    UiBottomSheetFooterDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMomentDateModule,
    MatNativeDateModule,
  ],
  exports: [
    SignaturePadComponent,
    ModuleErrorBannerComponent,
    AlertComponent,
    LoaderComponent,
    DocumentViewerComponent,
    FiltroResumenGuiasComponent,
    ModalConfirmarDatosComponent,
    ModalExportarComponent,
    SuccessDialogComponent,
    PdfCanvasViewerComponent,
    UiTableComponent,
    UiFiltersComponent,
    UiBottomSheetComponent,
    UiBottomSheetFooterDirective,
  ],
})
export class SharedUiModule {}
